/**
 * @fileoverview Barrel exports for the continuity-committee-v2 COMPOSITE agent.
 *
 * Orchestrates three continuity primitives in parallel:
 * - chapter-continuity-checker-v2: Plot, timeline, logic
 * - character-continuity-checker-v2: Voice, traits, relationships
 * - item-continuity-checker-v2: Physical objects, states, existence
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  ContinuityResultSchema,
  FindingSchema,
  IssueSeverityEnum,
  type Input,
  type Output,
  type ContinuityResult,
} from './schema';

// Flow
export { flow, continuityCommitteeV2AgentFlow } from './flow';
